import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const HomeIcon: FC<React.PropsWithChildren<IconProps>> = ({
  color = theme.palette.primary.main,
  size,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.2 8.98853L2.98569 10.0274C2.73184 10.2446 2.35339 10.2109 2.14039 9.95204C1.92739 9.69322 1.9605 9.30734 2.21434 9.09017L8.82156 3.43733C9.50311 2.85422 10.4969 2.85422 11.1784 3.43733L13.4 5.33798V5.03922C13.4 4.70135 13.6686 4.42745 14 4.42745H15.2C15.5313 4.42745 15.8 4.70135 15.8 5.03922V7.39131L17.7857 9.09017C18.0395 9.30734 18.0726 9.69322 17.8596 9.95204C17.6466 10.2109 17.2682 10.2446 17.0143 10.0274L15.8 8.98851V15.0314C15.8 16.045 14.9941 16.8667 14 16.8667H5.99999C5.00588 16.8667 4.2 16.045 4.2 15.0314V8.98853ZM9.5929 4.37461C9.82835 4.17317 10.1717 4.17317 10.4071 4.37461L14.6 7.96185V15.0314C14.6 15.3692 14.3313 15.6431 14 15.6431H5.99999C5.66862 15.6431 5.39999 15.3692 5.39999 15.0314V7.96187L9.5929 4.37461Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
